module.exports = __webpack_public_path__ + "img/main_5.a13878f0.jpg";